export default __webpack_public_path__ + "static/mobile-clara-mesa-3a2378c48fb41730555fe4ccfe36eca2.png";